import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'spacers' })
export class SpacersPipe implements PipeTransform {
   transform( value: string ): string {
      if ( !value ) { return; }

      return value.replace( /_/g, ' ' );
   }
}

@Pipe({
   name: 'camelcase'
 })
 export class CamelCasePipe implements PipeTransform {
   transform(value: string): string {
     if (!value) return value;
 
     return value
       .toLowerCase()
       .split(' ')
       .map((word, index) =>
         index === 0
           ? word
           : word.charAt(0).toUpperCase() + word.slice(1)
       )
       .join('');
   }
 }